<app-topmenu
  [courseName]="configuration?.courseName"
  [menu]="configuration?.menu"
  [nextDecision]="nextDecision"
></app-topmenu>
<app-header
  [pageName]="title"
  [pageClass]="'company'"
  [data]="subMenu"
></app-header>
<div
  class="container"
  id="main-content"
  [ngClass]="{ 'my-3': subMenu?.items.length == 0 }"
>
  <app-submenu
    [data]="subMenu"
    [hidden]="subMenu?.items.length !== 1"
  ></app-submenu>
</div>
<hr class="hr-white" [hidden]="subMenu?.items.length !== 1" />
<div class="container">
  <div class="col-12 py-5" *ngIf="subtitle">
    <h2>{{ subtitle }}</h2>
  </div>
  <app-zonepanel [zones]="zones"></app-zonepanel>
</div>
<app-dialog #dialog></app-dialog>
<app-footer></app-footer>
<app-needhelp-button [token]="token" *ngIf="token"></app-needhelp-button>
